import React, { useCallback } from 'react';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import AkFlag, { FlagGroup } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { dismissDiagramPasteFlag } from '../../editor-commands/dismiss-diagram-paste-flag';
import type { MalleableUiPlugin } from '../../malleableUiPluginType';

type Props = {
	api?: ExtractInjectionAPI<MalleableUiPlugin>;
};

export const MauiDiagramPasteFlag = ({ api }: Props): React.JSX.Element | null => {
	const activeFlag = useSharedPluginStateWithSelector(
		api,
		['malleableUi'],
		(states) => states.malleableUiState?.diagramPaste?.activeFlag ?? null,
	);

	const onDismissed = useCallback(() => {
		api?.core.actions.execute(dismissDiagramPasteFlag());
	}, [api]);

	if (!activeFlag) {
		return null;
	}

	return (
		<FlagGroup>
			<AkFlag
				onDismissed={onDismissed}
				title={activeFlag.title}
				description={activeFlag.description}
				id={activeFlag.id}
				testId={activeFlag.id}
				icon={<StatusErrorIcon label="" color={token('color.icon.danger')} />}
			/>
		</FlagGroup>
	);
};
